<iframe
  width="100%"
  height="100%"
  [src]="url | safe : 'url'"
  title="YouTube video player"
  frameborder="0"
  referrerpolicy="strict-origin-when-cross-origin"
  (load)="iframeLoaded = true"
  class="rounded-xl"
></iframe>

@if (!iframeLoaded) {
<app-progress-spinner />
}
